var _path, _path2, _path3, _path4, _line, _line2, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlant(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.4328 36.6484H15.0944C14.874 36.6484 14.6953 36.8313 14.6953 37.0568C14.6953 37.2824 14.874 37.4652 15.0944 37.4652H33.4328C33.6532 37.4652 33.8319 37.2824 33.8319 37.0568C33.8319 36.8313 33.6532 36.6484 33.4328 36.6484Z",
    fill: "#052B33"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7303 21.5947C21.7303 21.5947 24.7514 32.7025 19.8984 36.9619",
    stroke: "#052B33",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6872 21.5898C26.6872 21.5898 23.5702 32.6691 28.3873 36.9734",
    stroke: "#052B33",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9048 28.16C27.4286 28.009 28.5213 27.3896 28.701 26.1208C29.8236 26.1963 32.2035 25.8489 32.7424 23.8549C33.2813 21.861 32.3682 20.7583 31.8443 20.4562C32.5179 19.9275 33.5507 18.3716 32.2933 16.3777C31.036 14.3837 29.0752 14.4895 28.2519 14.7916C28.1022 14.0363 27.1742 12.4805 24.6595 12.2992C22.1448 12.1179 20.9174 13.7342 20.6181 14.5651C18.948 14.2011 17.0726 14.2011 15.9308 15.8433C14.7889 17.4855 15.1096 19.1278 15.6999 20.4562C15.1011 21.136 14.218 22.9034 15.4753 24.5348C16.7327 26.1662 18.6935 26.423 19.5168 26.3475C19.5916 26.9517 19.7413 27.9336 20.8639 28.16",
    stroke: "#052B33",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 19.7769,
    y1: 31.309,
    x2: 16.7984,
    y2: 31.309,
    stroke: "#052B33",
    strokeWidth: 0.821115,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 31.1832,
    y1: 31.309,
    x2: 28.2046,
    y2: 31.309,
    stroke: "#052B33",
    strokeWidth: 0.821115,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9375 30.3496L31.9107 31.3311L30.9375 32.3125",
    stroke: "#052B33",
    strokeWidth: 0.821115,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8281 30.3496L15.8549 31.3311L16.8281 32.3125",
    stroke: "#052B33",
    strokeWidth: 0.821115,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlant);
export default __webpack_public_path__ + "static/media/plant.884f22d68778f86c07cf4d47a400be7d.svg";
export { ForwardRef as ReactComponent };